import {updateVATUI} from "./priceswitch";

export const initSearch = () => {
    let searchIcon = document.querySelector('.svg-icon-search');
    let searchText = document.querySelector('.search-form__title');
    let closeIcon = document.querySelector('.close-icon');
    let form = searchIcon ? searchIcon.closest('form') : null;
    let searchInput = document.getElementById('search-input');

    const toggleSearchForm = () => {
        form.classList.toggle('form-active');
        searchIcon.classList.toggle('icon-active');
        closeIcon.classList.toggle('icon-active');
        searchText.classList.toggle('text-hide');

        // Show/Hide icons
        if (searchIcon.style.display === 'none') {
            searchIcon.style.display = 'block';
            closeIcon.style.display = 'none';
        } else {
            searchIcon.style.display = 'none';
            closeIcon.style.display = 'block';
        }

        searchInput.classList.toggle('input-active');
        searchInput.focus();
    };

    if (searchIcon && closeIcon && form && searchInput) {

        searchInput.placeholder = "Indtast mærke, fustage, bar eller lign.";

        searchIcon.addEventListener('click', toggleSearchForm);
        searchText.addEventListener('click', toggleSearchForm);

        closeIcon.addEventListener('click', function () {
            form.classList.remove('form-active');
            searchIcon.style.display = 'block';
            closeIcon.style.display = 'none';
            searchInput.classList.remove('input-active');
            searchInput.blur();

            setTimeout(function() {
                searchText.classList.toggle('text-hide');
            }, 600);
        });
    }

    // Populate search inputs from URL parameter
    populateSearchFromURL();

    // Initialize dynamic search links
    initDynamicSearchLinks();
};

/**
 * Populate search inputs with the term from URL query parameter
 */
export const populateSearchFromURL = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const term = urlParams.get('term');

    if (term) {
        // Find all search inputs and populate them
        const searchInputs = document.querySelectorAll('input[name="term"]');
        searchInputs.forEach((input) => {
            input.value = decodeURIComponent(term);
        });
    }
};

/**
 * Updates search button and "Se alle resultater" links dynamically based on search input
 * Uses HTMX events and keyup (same as HTMX) to avoid conflicts
 */
export const initDynamicSearchLinks = () => {
    const updateLinksFromInput = (input) => {
        const term = input.value.trim();
        const encodedTerm = encodeURIComponent(term);
        const url = term ? '/sog/?term=' + encodedTerm : '/sog/';

        // Update ALL search button links (there may be multiple on the page - desktop and mobile)
        const searchLinks = document.querySelectorAll('.search-link');
        searchLinks.forEach((searchLink) => {
            searchLink.href = url;
            searchLink.setAttribute('href', url);
        });

        // Update all "Se alle resultater" buttons
        const seeAllButtons = document.querySelectorAll('.see-all-results');
        seeAllButtons.forEach((button) => {
            button.href = url;
        });
    };

    // Listen to HTMX beforeRequest event - this fires when HTMX is about to send a request
    document.body.addEventListener('htmx:beforeRequest', (event) => {
        const target = event.target;

        // Check if this is a search input triggering
        if (target && target.matches && target.matches('input[name="term"]')) {
            updateLinksFromInput(target);
        }
    });

    // Also listen to keyup on search inputs (same event HTMX uses) as a backup
    document.body.addEventListener('keyup', (event) => {
        const target = event.target;

        if (target && target.matches && target.matches('input[name="term"]')) {
            updateLinksFromInput(target);
        }
    });

    // Re-run after HTMX processes dropdown results to update "Se alle resultater" buttons
    document.body.addEventListener('htmx:afterSwap', (event) => {
        if (event.detail.target.id === 'search-results' || event.detail.target.id === 'search-results-top') {
            // Find the active search input and update links based on its value
            const activeInput = document.querySelector('input[name="term"]:focus') ||
                               document.querySelector('input[name="term"]');

            if (activeInput) {
                updateLinksFromInput(activeInput);
            }
        }
    });

    // Attach click handlers directly to search links
    const attachClickHandlers = () => {
        const searchLinks = document.querySelectorAll('.search-link');

        searchLinks.forEach((searchLink) => {
            // Remove any existing listeners by cloning
            const newSearchLink = searchLink.cloneNode(true);
            searchLink.parentNode.replaceChild(newSearchLink, searchLink);

            newSearchLink.addEventListener('click', (event) => {
                // Prevent the default navigation
                event.preventDefault();
                event.stopPropagation();

                // Get the current search term from the closest form
                const form = newSearchLink.closest('form');
                const input = form ? form.querySelector('input[name="term"]') : document.querySelector('input[name="term"]');

                if (input && input.value.trim()) {
                    const term = encodeURIComponent(input.value.trim());
                    const url = '/sog/?term=' + term;
                    window.location.href = url;
                } else {
                    window.location.href = '/sog/';
                }
            });
        });
    };

    // Attach handlers on init
    attachClickHandlers();

    // Re-attach after HTMX swaps (in case new search links are added)
    document.body.addEventListener('htmx:afterSwap', (event) => {
        if (event.detail.target.id === 'search-results' || event.detail.target.id === 'search-results-top') {
            setTimeout(attachClickHandlers, 0);
        }
    });

    // Re-apply VAT/moms preference to HTMX-loaded content
    document.body.addEventListener('htmx:afterSwap', () => {
        const serverDefault = document.querySelector('.js-price-switch')?.dataset.vatDefault === '1' ? 'with-vat' : 'without-vat';
        const savedPreference = localStorage.getItem('priceType') || serverDefault;
        updateVATUI(savedPreference);
    });
};